module.exports = __webpack_public_path__ + "img/fabrica-4.fa75b555.jpeg";